import React from 'react'
import FramerText from '../hocs/FramerText'

let cached = 0

const Svg38 = ({ scenario, ...rest }) => {
  let value = scenario ? scenario.value : 1.24
  value = value.toFixed(2)
  const lastValue = cached

  cached = value
  return (
    <svg width={60} height={58} {...rest}>
      <g fill="none" fillRule="evenodd">
        <path fill="#EEE6D9" d="M4 14h37a4 4 0 014 4v27H0V18a4 4 0 014-4z" />
        <text
          fill="#231F20"
          fontFamily="Montserrat-SemiBold, Montserrat"
          fontSize={16}
          fontWeight={500}
          letterSpacing={0.091}
          textAnchor="middle"
          alignmentBaseline="middle"
        >
          <FramerText
            value={value}
            lastValue={lastValue}
            order={scenario && scenario.order ? scenario.order : 1}
            x={23}
            y={36}
          />
        </text>
        <path fill="#B77941" d="M0 45h45v9a4 4 0 01-4 4H4a4 4 0 01-4-4v-9z" />
        <text
          fill="#FFF"
          fontFamily="Montserrat-Medium, Montserrat"
          fontSize={9}
          fontWeight={400}
          letterSpacing={-0.206}
        >
          <tspan x={9} y={54}>
            {'\xA3/mile'}
          </tspan>
        </text>
        <path
          fill="#B77941"
          fillRule="nonzero"
          d="M4.18 8.08C2.06 8.08.48 6.57.48 4.5.48 2.43 2.06.92 4.19.92c1.08 0 2.02.37 2.66 1.09l-.65.63c-.54-.57-1.2-.83-1.97-.83-1.58 0-2.75 1.14-2.75 2.69s1.17 2.69 2.75 2.69c.77 0 1.43-.27 1.97-.84l.65.63c-.64.72-1.58 1.1-2.67 1.1zm5.581-.02c-1.59 0-2.76-1.13-2.76-2.71s1.17-2.7 2.76-2.7c1.59 0 2.75 1.12 2.75 2.7s-1.16 2.71-2.75 2.71zm0-.84c1.02 0 1.78-.74 1.78-1.87 0-1.13-.76-1.86-1.78-1.86s-1.79.73-1.79 1.86c0 1.13.77 1.87 1.79 1.87zm5.172.84c-.88 0-1.75-.27-2.19-.62l.4-.76c.45.32 1.17.55 1.86.55.89 0 1.26-.27 1.26-.72 0-1.19-3.35-.16-3.35-2.27 0-.95.85-1.59 2.21-1.59.69 0 1.47.18 1.93.48l-.41.76c-.48-.31-1.01-.42-1.53-.42-.84 0-1.25.31-1.25.73 0 1.25 3.36.23 3.36 2.29 0 .96-.88 1.57-2.29 1.57zM20.674 7l.3.69c-.29.25-.73.37-1.16.37-1.07 0-1.68-.59-1.68-1.66V3.49h-.9V2.7h.9V1.54h.96V2.7h1.52v.79h-1.52v2.87c0 .57.3.89.83.89.28 0 .55-.09.75-.25zm5.563 1.06c-1.59 0-2.76-1.13-2.76-2.71s1.17-2.7 2.76-2.7c1.59 0 2.75 1.12 2.75 2.7s-1.16 2.71-2.75 2.71zm0-.84c1.02 0 1.78-.74 1.78-1.87 0-1.13-.76-1.86-1.78-1.86s-1.79.73-1.79 1.86c0 1.13.77 1.87 1.79 1.87zm5.592-5.91c-.57 0-.86.32-.86.93v.46h1.54v.79h-1.52V8h-.96V3.49h-.9V2.7h.9v-.47c0-1.03.62-1.71 1.75-1.71.41 0 .81.1 1.08.31l-.29.73c-.2-.15-.46-.25-.74-.25zM37.93 7l.3.69c-.29.25-.73.37-1.16.37-1.07 0-1.68-.59-1.68-1.66V3.49h-.9V2.7h.9V1.54h.96V2.7h1.52v.79h-1.52v2.87c0 .57.3.89.83.89.28 0 .55-.09.75-.25zm1.952-3.41c.34-.62 1-.94 1.93-.94v.93c-.08-.01-.15-.01-.22-.01-1.03 0-1.67.63-1.67 1.79V8h-.96V2.7h.92v.89zm4.601-.94c1.45 0 2.27.7 2.27 2.15V8h-.91v-.7c-.32.48-.91.76-1.74.76-1.2 0-1.96-.64-1.96-1.56 0-.85.55-1.55 2.13-1.55h1.52v-.19c0-.81-.47-1.28-1.42-1.28-.63 0-1.27.22-1.68.57l-.4-.72c.55-.44 1.34-.68 2.19-.68zm-.22 4.67c.72 0 1.29-.33 1.53-.94v-.74h-1.48c-.95 0-1.22.37-1.22.82 0 .53.44.86 1.17.86zm7.492-4.62h.94L50.376 8h-.98l-2.32-5.3h1l1.82 4.25 1.86-4.25zm6.051 2.68c0 .08-.01.2-.02.29h-4.3c.12.93.87 1.55 1.92 1.55.62 0 1.14-.21 1.53-.64l.53.62c-.48.56-1.21.86-2.09.86-1.71 0-2.85-1.13-2.85-2.71 0-1.57 1.13-2.7 2.66-2.7 1.53 0 2.62 1.1 2.62 2.73zm-2.62-1.92c-.92 0-1.6.62-1.7 1.52h3.4c-.1-.89-.77-1.52-1.7-1.52zM58.71 8V.58h.96V8h-.96z"
        />
      </g>
    </svg>
  )
}
export default Svg38
